import React from "react";
import { Draggable } from "../../core/core-widgets/surfaces/Draggable/Draggable";
import TreeItemFinder from "../../layers/util/TreeItemFinder";
import ItemLookUp from "./ItemLookUp";
import ItemTree from "./ItemTree";
import DataSetFilterItem from "../../filter/DataSetFilter/dto/DataSetFilterItem";
import { Position } from "../../core/core-widgets/surfaces/Draggable/types";

interface LayerElementProps {
    id: string;
    className: string;

    treeItems: DataSetFilterItem[];
    readonly?: boolean;

    lookUpItems: DataSetFilterItem[];
    lookUpTitle: string;
    lookupFilterMessage: string;

    onTreeItemAdd?: () => void;
    onTreeItemRemove: (filterId: number) => void;
    onTreeItemVisibilityChange: (filterId: number, visibility: boolean) => void;
    onTreeItemClick?: () => void;
    onRefresh?: () => void;

    onLookupItemAdd?: (filterId: string) => void;
}

interface LayerElementState {
    lookUpOpened: boolean;
    treeItems: DataSetFilterItem[];
    lookUpItems: DataSetFilterItem[];
    lookupPosition?: Position;
}

class LayerElement extends React.Component<LayerElementProps, LayerElementState> {
    itemTreeRef: React.RefObject<HTMLDivElement>;

    constructor(props: LayerElementProps) {
        super(props);

        this.itemTreeRef = React.createRef();

        this.state = {
            lookUpOpened: false,
            treeItems: props.treeItems,
            lookUpItems: [],
        };
    }

    static defaultProps = {
        id: "layerElement",
        className: "layerElement",
        lookUpItems: [],
        lookUpTitle: "Layer Element",
        lookupFilterMessage: "Search Elements",
    };

    UNSAFE_componentWillReceiveProps(newProps: LayerElementProps) {
        let treeItemIds: string[] = [];
        for (let i = 0; i < newProps.treeItems.length; i++) {
            const itemIds = TreeItemFinder.getItemAndItsChildren(newProps.treeItems[i]).map((item) => item.id);
            treeItemIds = treeItemIds.concat(itemIds);
        }
        this.setState({
            treeItems: newProps.treeItems,
            lookUpItems: newProps.lookUpItems.filter((item) => !treeItemIds.includes(item.id)),
        });
    }

    render() {
        const lookupEnabled =
            (this.state.lookUpOpened && this.state.lookUpItems && this.state.lookUpItems.length > 0) ?? false;

        return (
            <>
                <Draggable
                    preferredPosition={this.state.lookupPosition}
                    applyWindowBoundaries={true}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        minWidth: 300,
                        wordWrap: "break-word",
                        zIndex: 9999999999999999999,
                        backgroundColor: "white",
                        boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 4px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        height: "auto",
                    }}
                >
                    <ItemLookUp
                        enabled={lookupEnabled}
                        id={`${this.props.id}ItemLookUp`}
                        className={`${this.props.className}ItemLookUp`}
                        title={this.props.lookUpTitle}
                        filterMessage={this.props.lookupFilterMessage}
                        items={this.state.lookUpItems}
                        onClose={this.handleLookUpClose.bind(this)}
                        onAdd={this.props.onLookupItemAdd}
                    />
                </Draggable>

                <ItemTree
                    id={`${this.props.id}ItemTree`}
                    className={this.props.className}
                    items={this.state.treeItems}
                    onExpand={this.handleTreeItemExpanded.bind(this)}
                    onAdd={!this.props.readonly && this.props.onTreeItemAdd ? this.handleLookUpOpen.bind(this) : null}
                    onHide={!this.props.readonly && this.props.onTreeItemVisibilityChange}
                    onRemove={!this.props.readonly && this.props.onTreeItemRemove}
                    onRowClick={this.props.onTreeItemClick}
                    onRefresh={!this.props.readonly && this.props.onRefresh}
                    readonly={this.props.readonly}
                    treeRef={this.itemTreeRef}
                />
            </>
        );
    }

    handleLookUpOpen() {
        if (this.props.onTreeItemAdd) {
            this.props.onTreeItemAdd();
        }
        const itemTreeRectangle = this.itemTreeRef.current?.getBoundingClientRect();
        this.setState({
            lookupPosition: {
                x: itemTreeRectangle?.left! + itemTreeRectangle?.width!,
                y: itemTreeRectangle?.top!,
            },
            lookUpOpened: true,
        });
    }

    handleLookUpClose() {
        this.setState({
            lookUpOpened: false,
        });
    }

    handleTreeItemExpanded(itemId: string, expand: boolean) {
        const items = [...this.state.treeItems];
        const item = TreeItemFinder.findItem(itemId, items);

        item.expanded = expand;
        this.setState({
            treeItems: items,
        });
    }
}

export default LayerElement;
